import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class RedCardDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"CARTON ROUGE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "CARTON ROUGE",
            player: event.detail?.player,
            reason: event.detail?.reason,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    get reason() {
        return this.detail.reason;
    }
    set reason(value) {
        this.detail.reason = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "reason"].includes(key)){
            let commentaire = "Carton rouge"

            const team = getTeam(this.team, match)
            const cardPlayer = getPlayer(this.player, match, team)

            if(this.player){
                if(cardPlayer){
                    commentaire += ' pour '+ cardPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(this.reason){
                switch(this.reason){
                    case 'lastdef':
                        commentaire+='Raison : Dernier défenseur.'
                    break
                    case 'dangerous':
                        commentaire+='Raison : Faute dangereuse.'
                    break
                }
            }

            this.text = commentaire
        }
    }
}